import { DUPLICATEINVOICE_SUCCESS, DUPLICATEINVOICE_FAIL } from '../actionTypes';

const initialState = {
    user: null,
};

const duplicateInvoiceReducer = (state = initialState, action) => {
    switch (action.type) {
        case DUPLICATEINVOICE_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case DUPLICATEINVOICE_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }
    return state;
};

export default duplicateInvoiceReducer;
